import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { User, Mail } from 'lucide-react';
import { format } from 'date-fns';

export function GuestCheckoutDialog({
  open, onOpenChange, service, selectedDate, selectedTime, totalPrice,
  guestName, setGuestName, guestEmail, setGuestEmail,
  guestPhone, setGuestPhone, bookingLoading, onSubmit, serviceId
}) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Complete Your Booking</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <p className="text-sm text-stone-500">
            Enter your details to complete your booking. No account required!
          </p>
          
          <div className="space-y-2">
            <Label htmlFor="guest-name">Your Name *</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
              <Input
                id="guest-name"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                placeholder="Enter your name"
                className="input-zuriya pl-10"
                data-testid="guest-name-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="guest-email">Email Address *</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
              <Input
                id="guest-email"
                type="email"
                value={guestEmail}
                onChange={(e) => setGuestEmail(e.target.value)}
                placeholder="your@email.com"
                className="input-zuriya pl-10"
                data-testid="guest-email-input"
              />
            </div>
            <p className="text-xs text-stone-400">We'll send your booking confirmation here</p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="guest-phone">Phone Number (Optional)</Label>
            <Input
              id="guest-phone"
              type="tel"
              value={guestPhone}
              onChange={(e) => setGuestPhone(e.target.value)}
              placeholder="07xxx xxxxxx"
              className="input-zuriya"
              data-testid="guest-phone-input"
            />
          </div>

          <div className="p-4 bg-[#F9F6F0] rounded-lg">
            <div className="text-sm space-y-1">
              <p className="flex justify-between">
                <span className="text-stone-500">Service:</span>
                <span className="font-medium">{service?.name}</span>
              </p>
              <p className="flex justify-between">
                <span className="text-stone-500">Date:</span>
                <span className="font-medium">{selectedDate ? format(selectedDate, 'd MMM yyyy') : ''}</span>
              </p>
              <p className="flex justify-between">
                <span className="text-stone-500">Time:</span>
                <span className="font-medium">{selectedTime}</span>
              </p>
              <div className="pt-2 mt-2 border-t border-[#E6E4DD] flex justify-between">
                <span className="font-medium">Total:</span>
                <span className="font-semibold text-[#D4AF37]">£{totalPrice.toFixed(2)}</span>
              </div>
            </div>
          </div>

          <Button 
            onClick={onSubmit}
            disabled={bookingLoading || !guestName || !guestEmail}
            className="w-full btn-primary h-12"
            data-testid="guest-checkout-btn"
          >
            {bookingLoading ? 'Processing...' : 'Continue to Payment'}
          </Button>

          <p className="text-center text-xs text-stone-400">
            Want to manage your bookings?{' '}
            <button 
              onClick={() => {
                onOpenChange(false);
                navigate('/register', { state: { from: `/service/${serviceId}` } });
              }}
              className="text-[#D4AF37] hover:underline"
            >
              Create an account
            </button>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
